(
    function(skyward, $, undefined)
    {
        "use strict";
        skyward.specialprogramswa = skyward.specialprogramswa || {};

        var init = function (selector)
        {
            var endDate = $(selector).find(".SpecialProgramsWAEndDate");
            var exitReasonCodeEEL = $(selector).find(".SpecialProgramsWAStateSpecialProgramExitReason");
            if (endDate.length < 1 || exitReasonCodeEEL.length < 1)
            {
                return;
            }

            var controlPrefix = endDate.attr('id').replace('EndDate', '');

            var endDateOnChange = function ()
            {
                skyward.specialprogramswa.endDateOnChange(endDate, exitReasonCodeEEL, controlPrefix);
            };

            skyward.specialprogramswa.endDateOnChange(endDate, exitReasonCodeEEL, controlPrefix);
            endDate.on("change", endDateOnChange);
            exitReasonCodeEEL.on("change", endDateOnChange);
        };

        skyward.specialprogramswa.endDateOnChange = function (endDate, exitReasonCodeEel, controlPrefix)
        {
            if (skyward.controls.getValue(endDate).isValidDate() || skyward.controls.getValue(exitReasonCodeEel) != "")
            {
                $('#' + controlPrefix + 'EndDateNonRequiredLabel').hide();
                $('#' + controlPrefix + 'EndDateRequiredLabel').show();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonNonRequiredLabel').hide();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonRequiredLabel').show();
            }
            else
            {
                $('#' + controlPrefix + 'EndDateNonRequiredLabel').show();
                $('#' + controlPrefix + 'EndDateRequiredLabel').hide();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonNonRequiredLabel').show();
                $('#' + controlPrefix + 'StateSpecialProgramExitReasonRequiredLabel').hide();
            }
        };

        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);